var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('button',{staticClass:"product-button",on:{"click":_vm.handleButtonClick}},[_c('img',{attrs:{"src":_vm.logo}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }